export const familyDefinitions: Record<string, string> = {
  AFS: "Administration, Facilities & Secretarial",
  AMT: "Asset/Investment Management",
  CCA: "Communications & Corporate Affairs",
  CCB: "Consumer & Commercial Banking",
  CMB: "Capital Markets/Investment Banking",
  CON: "Construction",
  CRT: "Creative & Design",
  CSV: "Customer Service & Contact Center Operations",
  DAW: "Data Analytics/Warehousing, & Business Intelligence",
  DEX: "Drilling, Exploration & Operations",
  EGS: "Energy Generation & Supply",
  ENS: "Engineering & Science",
  FIN: "Finance",
  GMA: "General Management",
  HLT: "Healthcare/Pharmacy Services",
  HPY: "Hospitality (Food Service & Lodging)",
  HRM: "Human Resources",
  INS: "Insurance",
  ITC: "IT, Telecom & Internet",
  LCA: "Legal, Compliance & Audit",
  PPM: "Project/Program Management",
  PSK: "Production & Skilled Trades",
  QLT: "Quality Management",
  REA: "Real Estate Management, Property Development & Investment",
  RET: "Retail",
  SCN: "Supply Chain",
  SMP: "Sales, Marketing & Product Management",
  TNS: "Transportation Services",
  TRD: "Trading & Dealing",
  AA: "Administrative Services",
  AC: "Corporate Support",
  AD: "Data",
  AF: "Finance",
  AH: "Human Resources",
  AI: "Information Technology",
  AL: "Legal",
  AM: "General Management/Executive",
  AR: "Regulatory Affairs",
  AS: "Safety & Security",
  AT: "Transportation",
  AX: "G&A - Other",
  OD: "Distribution",
  OF: "Flight Operations",
  OG: "General",
  OM: "Manufacturing",
  OX: "Operations - Other",
  PC: "Customer Support",
  PE: "Training/Education",
  PO: "Outsourcing",
  PP: "Core Professional Services",
  PX: "Services - Other",
  RA: "Aerospace Engineering",
  RC: "Chemical/Materials Engineering",
  RD: "Clinical Development",
  RG: "General Research & Development",
  RH: "Hardware",
  RM: "Research",
  RP: "Product Development",
  RQ: "Quality",
  RS: "Software",
  RU: "Development Support",
  RV: "Gaming",
  RX: "R&D - Other",
  SM: "Marketing",
  SR: "Retail Operations",
  SS: "Sales",
  SU: "Sales Support",
  SW: "Web/E Commerce",
  SX: "Sales & Marketing - Other",
  XX: "Generic - Other",
};

export const subFamilyDefinitions: Record<string, Record<string, string>> = {
  AFS: {
    "01": "Administration & Secretarial",
    "02": "Facilities Management & Planning",
    "03": "Facilities Refurbishment, Repair & Maintenance",
    "04": "Facilities/Grounds, Custodial, Cleaning & Laundry",
    "05": "Property, Facilities & Asset Security",
    "07": "Library Services",
    "08": "Safety Services",
  },
  AMT: { "05": "Trust & Estates" },
  CCA: {
    "01": "Communications & Corporate Affairs Leadership",
    "02": "Communications & Corporate Affairs Generalists",
    "03": "Employee Communications & Collaboration",
    "04": "Corporate Affairs",
    "05": "Investor Relations",
  },
  CCB: {
    "01": "Consumer & Commercial Banking Leadership",
    "02": "Branch Banking",
    "03": "Wholesale/Transaction Banking",
    "04": "Lending & Leasing Operations",
    "05": "Financial Planning & Investment Advisory Services",
    "06": "Consumer & Commercial Banking Operations",
  },
  CMB: {
    "03": "Corporate Financing Advisory Services",
    "04": "Brokerage Sales & Services",
    "05": "Treasury Services",
    "06": "Investment Banking Operations",
  },
  CON: {
    "01": "Construction Leadership",
    "02": "Construction Planning, Design & Delivery",
  },
  CRT: {
    "01": "Product Creative/Industrial Design",
    "02": "Media/Communications Creative & Design",
    "03": "Web/New Media Creative & User Interface Design",
    "04": "Advertising Creative, Design & Production",
    "09": "Architecture & Interior/Landscape Design",
  },
  CSV: {
    "01": "Customer Service & Contact Center Operations Leadership",
    "02": "Customer Service",
    "03": "Customer Relationship Management, Issue Resolution & Account Activation",
    "04": "Contact Center Operations & Training",
  },
  DAW: {
    "02": "Data Analytics & Business Intelligence (BI)",
    "03": "Internal Data Engineering & Warehousing",
    "04": "Back-End Transaction/Data Processing",
  },
  DEX: {
    10: "Mining Technical Services",
    11: "Energy & Mining Maintenance Operations",
    "01": "Drilling, Exploration & Operations Leadership",
    "02": "Exploration & Production Operations",
    "03": "Drilling Operations",
    "04": "Pipeline Operations",
    "05": "Refining Operations",
    "06": "Oilfield Services Operations",
    "07": "Mining Exploration",
    "08": "Mining Project Development",
    "09": "Mining Operations",
  },
  EGS: {
    "01": "Power Generation, Transmission & Distribution",
    "02": "Utilities Operations",
    "03": "Renewable Energy Asset Management",
  },
  ENS: {
    10: "Engineering Technologists & Technicians",
    11: "Engineering Program Management",
    "01": "Joint Engineering & Science Technical Leadership",
    "02": "Technical Product Development/Research Operations",
    "03": "Engineering",
    "06": "Engineering Design Services",
    "07": "Science",
    "08": "Science Technical Research",
    "09": "Science Research & Quality Laboratory Services",
  },
  FIN: {
    10: "Credit & Collections",
    "01": "Finance & Accounting Leadership",
    "02": "Finance Generalists",
    "04": "Financial Control",
    "05": "Management Accounting",
    "06": "Accounting",
    "07": "Tax",
    "08": "Treasury",
    "09": "Accounts Payable/Receivable",
  },
  GMA: {
    "01": "General Management",
    "02": "Business Strategy & Planning",
    "03": "Risk Management",
  },
  HLT: {
    12: "Personal Care Services",
    "03": "Physician Services",
    "04": "Nursing Services",
    "05": "Pharmacy Services",
    "07": "Behavioral Health/Social Services",
  },
  HPY: {
    "02": "Banqueting/Conferencing/Catering Operations",
    "03": "Non-Restaurant Food Service Provider Operations",
    "04": "Food & Beverage Planning & Preparation",
    "05": "Food Product Development",
  },
  HRM: {
    10: "Training & Development (Internal)",
    "01": "Human Resources Leadership",
    "02": "Human Resources Generalists",
    "03": "Mobility",
    "04": "Compensation & Benefits",
    "05": "Human Resources Operations",
    "06": "Payroll",
    "07": "Employee/Labor Relations & Diversity",
    "08": "Talent Acquisition",
    "09": "Talent Management & Organization Development",
  },
  INS: {
    "02": "Underwriting & Loss Control",
    "03": "Claims Services",
    "05": "Policy Services",
    "06": "Agency/Field Services",
    "07": "Insurance Operations",
  },
  ITC: {
    10: "IT User Support",
    11: "Information Systems Operations & Production Control",
    12: "External Client IT Consulting",
    13: "Software Product Engineering",
    15: "Telecommunications Network Planning, Operations & Site Acquisition",
    "01": "IT, Telecom & Internet Leadership",
    "02": "IT, Telecom & Internet Generalists",
    "03": "Information Systems Architecture",
    "04": "IT Business Systems Analysts",
    "05": "IT Systems Configuration & Programming",
    "06": "IT Applications Development",
    "07": "IT Security",
    "08": "IT Infrastructure & Systems Administration",
    "09": "Information Systems Administration & Reporting",
  },
  LCA: {
    "01": "Corporate Compliance & Legal Leadership",
    "02": "Legal & Compliance Management",
    "03": "Legal",
    "04": "Regulatory Affairs",
    "05": "Internal Audit",
    "06": "Fraud Management",
    "07": "Compliance",
    "09": "Environmental and Employee Health & Safety",
  },
  PPM: {
    "01": "General Business Project/Program Management",
    "02": "Technical Project/Program Management",
    "03": "Construction & Property Development Project Management",
  },
  PSK: {
    "01": "Manufacturing Plant Management",
    "02": "Manufacturing Production, Processing & Assembly",
    "03": "Production Planning & Control",
    "04": "Machine Operations",
    "05": "Repair & Maintenance Trades",
    "06": "Heavy Equipment & Construction Trades",
    "08": "Food & Beverage Processing",
  },
  QLT: {
    "01": "Quality Management Leadership",
    "02": "Business Process/Service Quality",
    "03": "Manufacturing/Product Quality",
    "04": "Supplier Quality",
    "05": "General Business Quality Management",
  },
  REA: {
    "01": "General Real Estate Management",
    "02": "Property Management",
    "03": "Real Estate Acquisition, Planning & Development",
    "04": "Real Estate Asset & Investment Management",
    "05": "Real Estate Land Management",
  },
  RET: {
    "01": "Retail Store Management",
    "02": "Retail Store Operations (Non-Sales)",
    "05": "Retail Training & Development",
    "06": "Merchandising",
  },
  SCN: {
    "01": "Supply Chain Leadership",
    "02": "Supply Chain Planning & Operations",
    "03": "Procurement",
    "04": "Logistics",
    "05": "Warehousing & Distribution",
    "06": "Import/Export & Customs Operations",
  },
  SMP: {
    10: "Sales Training",
    11: "Sales Operations/Administration",
    12: "Franchise/Dealer Channel Development & Support",
    "01": "Sales, Marketing & Product Management Leadership",
    "02": "Sales & Marketing",
    "03": "Marketing Generalists",
    "04": "Product Marketing & Management",
    "05": "Advertising & Marketing Communications",
    "06": "Market Research & Analysis",
    "07": "Field Sales & Account Management",
    "08": "Remote/Telesales & Account Management",
    "09": "Account & Client Management",
  },
  TNS: {
    "02": "General Transportation Services",
    "03": "Road Transportation",
    "05": "Air Transportation",
  },
  TRD: {
    "01": "Traders",
    "03": "Trading & Dealing Operations",
    "04": "Trading Origination",
  },
};

export const levelDefinitions: Record<string, string> = {
  MD: "Director",
  MM: "Manager",
  MT: "Team Leader",
  PE: "Entry/Developing Professional",
  PS: "Senior Professional",
  PX: "Expert Professional",
  SE: "Entry/Developing Support",
  SS: "Senior Support",
  EX: "Executive",
  S5: "S5 - Specialist",
  S4: "S4 - Advanced",
  S3: "S3 - Skilled",
  S2: "S2 - Proficient",
  S1: "S1 - Assoc",
  P8: "P8 - Fellow",
  P7: "P7 - Strategist",
  P6: "P6 - Advisory",
  P5: "P5 - Expert",
  P4: "P4 - Mastery",
  P3: "P3 - Proficiency",
  P2: "P2 - Developing",
  P1: "P1 - Entry",
  M6: "M6 - Sr Dir/Asc VP",
  M5: "M5 - Director",
  M4: "M4 - Senior Manager",
  M3: "M3 - Manager",
  M2: "M2 - Entry Mgr/Sr Spv",
  M1: "M1 - Supervisor",
  E4: "E4 - Officer",
  E3: "E3 - Exec VP",
  E2: "E2 - Sr VP",
  E1: "E1 - Vice President",
};

export const levelDescriptions: Record<string, string> = {
  MD: `This level ranges in oversight responsibilities. At one end of the spectrum, typically manages a department or small unit that includes multiple teams led by Managers and/or Team Leaders. 
  Responsibilities typically include: 
  • Ownership of short to mid-term (1-3 years) execution of functional strategy and the operational direction of the Department. 
  • Problems faced are often complex and require extensive investigation and analysis. 
  • Requires ability to influence others to accept practices and approaches, and ability to communicate and influence executive leadership.
  
  At the other end of the spectrum, the level typically manages multiple teams led by Managers. 
  Responsibilities typically include:
  • Ownership of short to mid-term (1-3 years) strategy execution and operational direction in alignment with parent/corporate organization objectives.
  • Decisions have a serious impact on the overall success or failure on area of accountability.
  • Interacts with executive leadership and others concerning matters of significance to the organization.`,
  MM: `The Manager level manages experienced professionals who exercise latitude and independence in assignments. The majority of time is spent overseeing area of responsibility, planning, prioritizing and/or directing the responsibilities of employees. Goal achievement is typically accomplished through performance of direct and/or indirect reports.
  Responsibilities typically include:
  • Policy and strategy implementation for short-term results (1 year or less).
  • Problems faced are difficult to moderately complex.
  • Influences others outside of own job area regarding policies, practices and procedures`,
  MT: `This level ranges in oversight responsibilities. At one end of the spectrum, the level supervises para-professional employees.
  Responsibilities typically include:
  • Setting day-to-day operational objectives for team.
  • Problems faced may be difficult but typically are not complex.
  • Ensures policies, practices and procedures are understood and followed by direct reports, customers and stakeholders.

  At the other end of the spectrum, the level supervises professional level employees (typically entry or experienced level) and may also supervise some para-professional employees.
  Responsibilities typically include:
  • Setting goals and objectives for team members for achievement of operational results.
  • Problems faced may be difficult but typically are not complex.
  • Ensures policies, practices and procedures are understood and followed by direct reports, customers and stakeholders."`,
  PE: `This level ranges in experience. At the less experienced end of the spectrum, the level applies broad theoretical job knowledge typically obtained through advanced education.
  May require the following proficiency:
  • Work is closely supervised.
  • Problems faced are not typically difficult or complex.
  • Explains facts, policies and practices related to job area.

  At the more experienced end of the spectrum, the level applies practical knowledge of job area typically obtained through advanced education and work experience.
  May require the following proficiency:
  • Works independently with general supervision.
  • Problems faced are difficult but typically not complex.
  • May influence others within the job area through explanation of facts, policies and practices.`,
  PS: `This level ranges in experience. At the less experienced end of the spectrum, the level applies advanced knowledge of job area typically obtained through advanced education and work experience.
  Responsibilities may include:
  • Managing projects / processes, working independently with limited supervision.
  • Coaching and reviewing the work of lower level professionals.
  • Problems faced are difficult and sometimes complex.

  At the more experienced end of the spectrum, the level is a recognized subject matter expert in job area typically obtained through advanced education and work experience.
  Responsibilities typically include:
  • Managing large projects or processes with limited oversight from manager.
  • Coaching, reviewing and delegating work to lower level professionals.
  • Problems faced are difficult and often complex.`,
  PX: `This level ranges in experience. At the less experienced end of the spectrum, the level is a recognized master in professional discipline typically obtained through advanced education and work experience.
  Responsibilities typically include:
  • Establishing operational plans for job area.
  • Developing and implementing new products, processes, standards or operational plans that will have impact on the achievement of functional results.
  • Requires communication with leadership

  At the more experienced end of the spectrum, this level is recognized both within and outside the organization as thought leader in area of expertise.
  Responsibilities typically include:
  • Recommending operational strategies and plans with direct impact on results.
  • Influencing business decisions made by leadership.
  • Problems are complex and multi-dimensional.
  • Requires communication with executive leadership on matters of strategic importance.`,
  SE: `This level ranges in experience. At the less experienced end of the spectrum, the level requires little to no prior knowledge or experience.
  • Work is routine or follows standard procedures.
  • Work is closely supervised.
  • Communicates information that requires little explanation or interpretation.

  At the more experienced end of the spectrum, the level requires basic knowledge of job procedures and tools obtained through work experience and may require vocational or technical education.
  May require the following proficiency:
  • Works under moderate supervision.
  • Problems are typically of a routine nature, but may at times require interpretation or deviation from standard procedures.
  • Communicates information that requires some explanation or interpretation.`,
  SS: `This level ranges in experience. At the less experienced end of the spectrum, the level requires broad knowledge of operational procedures and tools obtained through extensive work experience and may require vocational or technical education.
  May require the following proficiency:
  • Works under limited supervision for routine situations.
  • Provides assistance and training to lower level employees.
  • Problems typically are not routine and require analysis to understand.

  At the more experienced end of the spectrum, the level requires advanced knowledge of operational procedures and tools obtained through extensive work experience and may require vocational or technical education.
  Responsibilities may include:
  • Working under limited supervision for non-routine situations and may be responsible for leading daily operations.
  • Training, delegating and reviewing the work of lower level employees.
  • Problems are typically difficult and non-routine but not complex."`,
  EX: `The Executive level provides strategic vision and/or tactical/strategic direction.
  • Leads multiple teams of executives, directors, and managers.
  • The majority of time is spent overseeing area of responsibility directing the responsibilities of employees.
  • Goal achievement is typically accomplished through performance of direct and/or indirect reports.`,
};

export function getFamilyLabel(family: string): string {
  return familyDefinitions[family] ?? family;
}

export function getSubFamilyLabel(family: string, subFamily: string): string {
  return subFamilyDefinitions[family]?.[subFamily] ?? subFamily;
}

export function getLevelLabel(level: string): string {
  return levelDefinitions[level] ?? level;
}

export const jobCodeToSpecializationTitleMap = {
  "AFS.01.000": "No Specialization",
  "AFS.01.020": "Secretary/Administrative Assistant",
  "AFS.01.021": "Executive Secretary/Executive Assistant",
  "AFS.01.041": "General Office Operations Support",
  "AFS.01.042": "Reception/Telephone/Switchboard",
  "AFS.01.043": "Office/Mailroom/Clerical Support",
  "AFS.01.044": "Internal Events Planning/Coordination",
  "AFS.01.045": "Data Entry",
  "AFS.01.046": "Travel Coordination",
  "AFS.01.048": "Refreshment Services",
  "AFS.01.049": "Vehicle Fleet Administration",
  "AFS.01.050": "Confidential Property/Asset Control",
  "AFS.01.052": "Medical Screening",
  "AFS.01.060": "General Document Management",
  "AFS.01.061": "Document Control",
  "AFS.02.000": "No Specialization",
  "AFS.03.000": "No Specialization",
  "AFS.04.000": "No Specialization",
  "AFS.04.001": "Custodial/Cleaning",
  "AFS.04.002": "Groundskeeping",
  "AFS.04.003": "Swimming Pool Maintenance",
  "AFS.04.024": "Dishwasher",
  "AFS.04.065": "Valet Parking Attendant",
  "AFS.05.000": "No Specialization",
  "AFS.07.000": "No Specialization",
  "AFS.08.005": "Firefighting/Emergency Response Services",
  "AFS.08.006": "Executive Protection",
  "AMT.05.000": "No Specialization",
  "CCA.01.001": "Head of Communications & Corporate Affairs",
  "CCA.02.000": "No Specialization",
  "CCA.03.000": "No Specialization",
  "CCA.04.000": "No Specialization",
  "CCA.05.000": "No Specialization",
  "CCB.01.001": "Head of Consumer Banking (Financial Services)",
  "CCB.01.004": "Head of Commercial Banking (Financial Services)",
  "CCB.02.000": "No Specialization",
  "CCB.02.001": "Consumer Banking Group/Regional Branch Management (Financial Services)",
  "CCB.03.000": "No Specialization",
  "CCB.04.000": "No Specialization",
  "CCB.04.001": "Head of Consumer Lending (Financial Services)",
  "CCB.04.022": "Consumer Lending (Financial Services)",
  "CCB.05.000": "No Specialization",
  "CCB.06.000": "No Specialization",
  "CMB.03.000": "No Specialization",
  "CMB.04.000": "No Specialization",
  "CMB.05.000": "No Specialization",
  "CMB.06.000": "No Specialization",
  "CON.01.001": "Head of Construction",
  "CON.02.000": "No Specialization",
  "CRT.01.000": "No Specialization",
  "CRT.02.001": "General Graphic Art/Design",
  "CRT.02.002": "Visual Merchandising Graphic Design (Retail)",
  "CRT.02.003": "Visual Brand/Design",
  "CRT.02.024": "Advertising Photo Studio Management (Retail)",
  "CRT.02.025": "Advertising Photo Shoot Art Direction (Retail)",
  "CRT.02.026": "Advertising Photo Shoot Styling (Retail)",
  "CRT.02.027": "Advertising Photo Selection & Editing (Retail)",
  "CRT.02.030": "Photography",
  "CRT.02.050": "General Communications Design & Editorial",
  "CRT.02.079": "General Communications Writing & Editing",
  "CRT.02.080": "Technical Writing & Editing",
  "CRT.02.081": "Translation",
  "CRT.02.085": "Proofreading",
  "CRT.03.000": "No Specialization",
  "CRT.03.001": "Web Layout Design & Administration",
  "CRT.03.002": "Multi-Media Web Design",
  "CRT.03.023": "New Media/Digital Media Design",
  "CRT.03.024": "User Experience Design (UXD)",
  "CRT.03.025": "User Interface (UI) Design",
  "CRT.04.000": "No Specialization",
  "CRT.09.001": "Architecture",
  "CRT.09.023": "Landscape Design (Real Estate & Construction)",
  "CRT.09.045": "Interior Design (Real Estate & Construction)",
  "CSV.01.001": "Head of Customer Service",
  "CSV.01.002": "Head of Contact/Call Center Operations",
  "CSV.02.000": "No Specialization",
  "CSV.03.000": "No Specialization",
  "CSV.04.000": "No Specialization",
  "DAW.02.000": "No Specialization",
  "DAW.02.031": "Head of Actuarial Analytics (Insurance)",
  "DAW.03.000": "No Specialization",
  "DAW.04.000": "No Specialization",
  "DEX.01.001": "Head of Oil & Gas Operations (Oil & Gas)",
  "DEX.01.002": "Head of Mining Operations (Mining)",
  "DEX.02.000": "No Specialization",
  "DEX.02.001": "Head of Exploration & Production (Oil & Gas)",
  "DEX.02.002": "Head of Exploration (Oil & Gas)",
  "DEX.02.015": "Exploration & Production Operations Management (Oil & Gas)",
  "DEX.02.016": "Joint Venture Management (Oil & Gas)",
  "DEX.02.017": "Joint Venture Contract Analysis (Oil & Gas)",
  "DEX.02.025": "Exploration Operations Management (Oil & Gas)",
  "DEX.02.035": "Production Operations Management (Oil & Gas)",
  "DEX.02.037": "Production Operations: Heavy Oil (Oil & Gas)",
  "DEX.02.038": "Production Operations (Oil & Gas)",
  "DEX.02.040": "Production Field Administration (Oil & Gas)",
  "DEX.02.055": "Reservoir Exploitation Management (Oil & Gas)",
  "DEX.02.065": "Gas Plant Operations Management (Oil & Gas)",
  "DEX.02.080": "Extraction Plant Operations (Oil & Gas)",
  "DEX.03.000": "No Specialization",
  "DEX.03.001": "Head of Drilling Operations (Oil & Gas)",
  "DEX.03.007": "Field Service Equipment/Tool Operations - Oilfield Services (Oil & Gas)",
  "DEX.03.015": "Drilling (Oil & Gas)",
  "DEX.03.016": "Directional Drilling (Oil & Gas)",
  "DEX.03.017": "Drilling Support & Maintenance (Oil & Gas)",
  "DEX.03.018": "Mud Operations (Oil & Gas)",
  "DEX.03.019": "Derrick Operations (Oil & Gas)",
  "DEX.03.020": "General Labor (Energy & Mining)",
  "DEX.04.000": "No Specialization",
  "DEX.05.000": "No Specialization",
  "DEX.06.000": "No Specialization",
  "DEX.07.000": "No Specialization",
  "DEX.07.001": "Head of Exploration (Mining)",
  "DEX.08.000": "No Specialization",
  "DEX.09.000": "No Specialization",
  "DEX.09.004": "Mine Site Security (Mining)",
  "DEX.09.005": "Miner (Mining)",
  "DEX.09.017": "Plant/Mill Production Operations (Mining)",
  "DEX.09.029": "Dispatch Operations (Mining)",
  "DEX.09.032": "Blasting: Charge Up (Mining)",
  "DEX.09.033": "Blasting: Shotfirer (Mining)",
  "DEX.09.034": "Drilling (Mining)",
  "DEX.09.035": "Mining Operations Support (Mining)",
  "DEX.09.036": "Mining Operations Support: Beltrunner (Mining)",
  "DEX.09.037": "Mining Operations Support: Dewatering (Mining)",
  "DEX.09.042": "Mining Operations Support: Shaft (Mining)",
  "DEX.09.043": "Mining Operations: Control Room (Mining)",
  "DEX.09.044": "Mining Operations: Goldroom (Mining)",
  "DEX.09.045": "Drilling Equipment Operator (Mining)",
  "DEX.10.000": "No Specialization",
  "DEX.11.000": "No Specialization",
  "DEX.11.003": "Rig Tools & Equipment Repair (Oil & Gas)",
  "DEX.11.004": "Engine/Rig Equipment Maintenance (Oil & Gas)",
  "DEX.11.005": "Mining Equipment Maintenance: Lube/Fuel (Mining)",
  "EGS.01.001": "Head of Power Generation & Delivery (Utilities)",
  "EGS.01.010": "Power Plant Operations Management (Utilities & Renewables)",
  "EGS.01.011": "Power Plant Operations (Utilities & Renewables)",
  "EGS.01.012": "Site Management/Wind Farm/Solar Farm Operations Management (Renewables)",
  "EGS.01.013": "Power Plant Overhaul Management (Utilities)",
  "EGS.01.025": "Head of Transmission and Distribution Systems (Utilities)",
  "EGS.01.026": "Transmission and Distribution Systems Management (Utilities)",
  "EGS.01.027": "Field Operations Management (Utilities)",
  "EGS.01.028": "Control Center/Scheduling: Power Transmission (Utilities)",
  "EGS.01.029": "Underground Line/Facilities Location (Utilities)",
  "EGS.01.030": "Electric Transmission/Distribution Lines Installation & Maintenance (Utilities)",
  "EGS.01.031": "Power Station/Substation Systems Installation & Maintenance (Utilities)",
  "EGS.01.032": "Electric Transmission/Distribution Lines Ground Crew (Utilities)",
  "EGS.01.034": "Grid Planning (Utilities)",
  "EGS.01.035": "Substations Management (Utilities)",
  "EGS.01.036": "Tree Trimming (Utilities)",
  "EGS.01.050": "Utility Systems Repair & Maintenance Support (Utilities)",
  "EGS.02.000": "No Specialization",
  "EGS.02.001": "Head of Utilities Operations (Utilities)",
  "EGS.02.015": "Utilities Business Management (Utilities)",
  "EGS.02.025": "Electric Grid Interconnection Strategy & Planning (Utilities)",
  "EGS.02.026": "Power Management (Utilities)",
  "EGS.02.040": "Metering Operations Management (Utilities)",
  "EGS.02.041": "Meter Installation, Maintenance & Repair (Utilities)",
  "EGS.02.042": "Meter Reading (Utilities)",
  "EGS.02.043": "Automated Meter Infrastructure (AMI) Management (Utilities)",
  "EGS.02.055": "Water Treatment Plant Operations (Utilities)",
  "EGS.02.070": "Energy Efficiency & Conservation Management (Utilities)",
  "EGS.03.000": "No Specialization",
  "ENS.01.001": "Head of Manufacturing R&D/Technical Product Development",
  "ENS.01.002": "Head of Biopharmaceutical R&D (Life Sciences)",
  "ENS.02.001": "Technical Product Development",
  "ENS.02.002": "New Product Implementation Engineering",
  "ENS.02.003": "Pilot Plant Biological Manufacturing (Life Sciences)",
  "ENS.02.019": "Artificial Intelligence R&D (High Tech)",
  "ENS.02.020": "Cyber Research (High Tech)",
  "ENS.02.021": "Computer Vision R&D (High Tech)",
  "ENS.02.022": "Machine Learning R&D (High Tech)",
  "ENS.02.023": "Speech Recognition R&D (High Tech)",
  "ENS.02.024": "Natural Language Processing R&D (High Tech)",
  "ENS.02.025": "Network Product Development Engineering (Telecommunications)",
  "ENS.02.026":
    "Intelligent Network Value Added Services (IN-VAS) Product Planning (Telecommunications)",
  "ENS.02.027": "Artificial Neural Networks (High Tech)",
  "ENS.02.046": "Clinical Trial Management (Life Sciences)",
  "ENS.02.047": "Clinical Research - Non M.D. (Life Sciences & Education)",
  "ENS.02.048": "Clinical Trial Recruitment (Life Sciences)",
  "ENS.02.049": "Clinical Data Management (Life Sciences)",
  "ENS.02.050": "Clinical Supply Operations (Life Sciences)",
  "ENS.02.052": "Clinical Data Standards Administration (Life Sciences)",
  "ENS.02.053": "Clinical Operations Digital Development (Life Sciences)",
  "ENS.02.071": "Field Research Station Management (Agriculture)",
  "ENS.02.072": "Field Product Development Operations (Agriculture)",
  "ENS.02.093": "Research Operations Management",
  "ENS.03.001": "Head of Engineering",
  "ENS.03.002": "Head of Manufacturing Product Design & Production Engineering",
  "ENS.03.009": "General Engineering",
  "ENS.03.010": "Advanced Manufacturing Engineering (AME)",
  "ENS.03.013": "Mechanical Engineering",
  "ENS.03.014": "Chemical Engineering",
  "ENS.03.015": "Electrical Engineering",
  "ENS.03.016": "Electronics Engineering",
  "ENS.03.017": "Engineering Operations Management",
  "ENS.03.018": "Engineering Liaison",
  "ENS.03.019": "Product Support Engineering",
  "ENS.03.025": "Engineering Rotational Program",
  "ENS.03.037": "Facilities Engineering",
  "ENS.03.038": "Facilities Layout Engineering",
  "ENS.03.039": "Plant Construction & Maintenance Engineering",
  "ENS.03.040": "Pipeline/Piping Engineering (Oil & Gas)",
  "ENS.03.041": "Nuclear Plant Engineering (Utilities & Power)",
  "ENS.03.042": "Facilities Piping Engineering",
  "ENS.03.059": "Product Design Engineering",
  "ENS.03.060": "Mechanical Product Design Engineering",
  "ENS.03.061": "Electronics Product Design Engineering",
  "ENS.03.062": "Manufacturing Packaging Design Engineering",
  "ENS.03.063": "Radio Frequency (RF) Engineering",
  "ENS.03.064": "Medical Devices Design Engineering (Life Sciences)",
  "ENS.03.065": "General Integrated Circuit (IC) Design Engineering (High Tech)",
  "ENS.03.066": "Integrated Circuit (IC) Analog Design Engineering (High Tech)",
  "ENS.03.067": "Integrated Circuit (IC) Digital Design Engineering (High Tech)",
  "ENS.03.069": "Integrated Circuit (IC) Verification Engineering (High Tech)",
  "ENS.03.070": "Integration (Electronic and Mechanical) Engineering",
  "ENS.03.071": "Computer/Peripheral Hardware Engineering (High Tech)",
  "ENS.03.072": "Usability & Styling Industrial Design Engineering (High Tech)",
  "ENS.03.073": "Hardware/Software Product Usability Engineering (High Tech)",
  "ENS.03.074": "Materials Design Engineering",
  "ENS.03.080": "Computational Fluid Dynamics Engineering",
  "ENS.03.087": "Acoustics Engineering",
  "ENS.03.089": "Robotics Engineering",
  "ENS.03.091": "Optical Engineering (High Tech)",
  "ENS.03.092": "Baseband Engineering (High Tech)",
  "ENS.03.093": "Mechatronics Engineering",
  "ENS.03.094": "Modeling & Simulation Engineering",
  "ENS.03.095": "Nuclear Engineering",
  "ENS.03.096": "Signal & Image Process Engineering",
  "ENS.03.097": "Communications Systems Engineering (High Tech)",
  "ENS.03.098": "Electro-Optical Engineering (High Tech)",
  "ENS.03.099": "Microelectronics/Semiconductor Engineering (High Tech)",
  "ENS.03.108": "General Project Engineering",
  "ENS.03.109": "Manufacturing Industrial Optimization Engineering",
  "ENS.03.110": "Human Factors Engineering",
  "ENS.03.111": "Project Planning/Scheduling Engineering",
  "ENS.03.112": "Commissioning & Start-Up Engineering",
  "ENS.03.113": "Project Controls Engineering",
  "ENS.03.114": "Distribution Center Industrial Optimization Engineering",
  "ENS.03.116": "Project Procurement Engineering (Construction)",
  "ENS.03.117": "Project Site Engineering (Real Estate & Construction)",
  "ENS.03.118": "Mine Site Closure Planning & Engineering (Mining)",
  "ENS.03.119": "Power Systems Planning and Design Engineering (Utilities)",
  "ENS.03.120": "Utilities Transmission & Distribution Engineering (Utilities & Power)",
  "ENS.03.137": "Manufacturing Production Process Engineering",
  "ENS.03.138": "Manufacturing Assembly Process Engineering",
  "ENS.03.139": "Chemical Process Engineering",
  "ENS.03.140": "Manufacturing Yield/Failure Analysis Engineering",
  "ENS.03.141": "Process Engineering (Life Sciences)",
  "ENS.03.142": "Pharmaceutical/Biological Process Engineering (Life Sciences)",
  "ENS.03.148": "Metallurgy/Process Engineering (Mining)",
  "ENS.03.150": "Renewable Energy Modelling/Renewable Resource Analysis (Renewables)",
  "ENS.03.151": "Technology Transfer Engineering",
  "ENS.03.152": "Additive Manufacturing Engineering",
  "ENS.03.154": "Materials Process Engineering",
  "ENS.03.166": "Manufacturing Mechanical Equipment Engineering",
  "ENS.03.167": "Manufacturing Electrical Equipment Engineering",
  "ENS.03.169": "Welding Equipment Engineering",
  "ENS.03.170": "Electrical Instrumentation & Control Engineering",
  "ENS.03.171": "Field Production Engineering (Oil & Gas)",
  "ENS.03.172": "Completions Engineering (Oil & Gas)",
  "ENS.03.173": "Gas Operations Engineering (Oil & Gas)",
  "ENS.03.175": "Renewable Energy Engineering (Utilities & Renewables)",
  "ENS.03.176": "Wind Energy Engineering (Renewables)",
  "ENS.03.177": "Solar Power Engineering (Renewables)",
  "ENS.03.188": "Quality Assurance Engineering",
  "ENS.03.189": "Quality Control Engineering",
  "ENS.03.190": "Supplier Quality Management Engineering",
  "ENS.03.191": "Reliability Engineering",
  "ENS.03.192": "Systems Test Engineering (High Tech)",
  "ENS.03.193": "Hardware/Device Test Engineering (High Tech)",
  "ENS.03.199": "Quality Assurance/Control Engineering (Construction)",
  "ENS.03.200": "Reserves/Well Engineering (Oil & Gas)",
  "ENS.03.201": "Corrosion/Integrity Engineering (Oil & Gas)",
  "ENS.03.202": "Customer Quality Engineering",
  "ENS.03.203": "General Product Test Engineering",
  "ENS.03.204": "Sustaining Engineering",
  "ENS.03.205": "Verification Engineering",
  "ENS.03.206": "Component Engineering",
  "ENS.03.207": "Metrology Engineering",
  "ENS.03.208": "Mission Assurance Engineering (High Tech)",
  "ENS.03.209": "System Safety Engineering",
  "ENS.03.210": "Wind Turbine Test Engineering (Renewables)",
  "ENS.03.229": "General Repair & Maintenance Engineering",
  "ENS.03.249": "Environmental Engineering",
  "ENS.03.250": "Employee/Labor Health & Safety Engineering",
  "ENS.03.270": "Engineering Sales",
  "ENS.03.271": "Engineering Sales & Post-Sale Consulting",
  "ENS.03.272": "Field Service Engineering",
  "ENS.03.275": "Field Service Engineering - Oilfield Services (Oil & Gas)",
  "ENS.03.276": "Technical Products Support Engineering (Oil & Gas)",
  "ENS.03.277": "Field Sales Engineering: Animal Health (Life Sciences)",
  "ENS.03.278": "Field Engineering (Oil & Gas)",
  "ENS.03.294": "Civil/Construction/Structural Engineering",
  "ENS.03.295": "Structural Engineering: Buildings (Construction)",
  "ENS.03.297": "Heating & Ventilating Systems Engineering (Construction)",
  "ENS.03.300": "Water/Waste Engineering (Construction & Civil Infrastructure)",
  "ENS.03.301": "General Municipal Engineering (Construction & Civil Infrastructure)",
  "ENS.03.302": "Subsea Engineering",
  "ENS.03.304": "Geotechnical/Rock Mechanics Engineering (Oil & Gas, Mining)",
  "ENS.03.305": "Geomatics Engineering (Oil & Gas)",
  "ENS.03.323": "Network Planning & Design Engineering (Telecommunications)",
  "ENS.03.324": "Network Field Installation & Integration Engineering (Telecommunications)",
  "ENS.03.340": "Drilling Engineering (Oil & Gas)",
  "ENS.03.341": "Reservoir/Exploitation Engineering (Oil & Gas/Oilfield Services)",
  "ENS.03.342": "Mining Engineering (Mining)",
  "ENS.03.344": "Drill and Blast Engineering (Mining)",
  "ENS.03.450": "Aeronautical Engineering (High Tech)",
  "ENS.03.451": "Aerospace Structural Engineering (High Tech)",
  "ENS.03.452": "Aerospace Logistics Engineering (High Tech)",
  "ENS.03.453": "Guidance, Navigation & Control Engineering (High Tech)",
  "ENS.03.454": "Satellite Systems Engineering (High Tech)",
  "ENS.03.455": "Propulsion Engineering (High Tech)",
  "ENS.03.456": "Aircraft Support Engineering",
  "ENS.03.457": "Flight Simulation Engineering",
  "ENS.03.488": "Energy Efficiency Engineering (Renewables)",
  "ENS.06.001": "Manufacturing Product/System Design Services",
  "ENS.06.002": "Computer Aided Design & Drafting (CAD/CAM/CAE)",
  "ENS.06.003": "Manufacturing Industrial Model Making Support",
  "ENS.06.005": "Building Information Modelling (Construction)",
  "ENS.06.006": "Intelligent Electronic Device Systems Design (Construction)",
  "ENS.06.008": "Printed Circuit Board Design (High Tech)",
  "ENS.06.009": "Configuration Management",
  "ENS.06.010": "Engineering Design Checking",
  "ENS.06.028": "Engineering Technical Documentation",
  "ENS.07.000": "No Specialization",
  "ENS.07.011": "Chemistry",
  "ENS.07.012": "Physics",
  "ENS.07.021": "General Product/Process Research Science",
  "ENS.07.022": "Discovery Biology (Life Sciences)",
  "ENS.07.023": "Dosage Formulation Research (Life Sciences)",
  "ENS.07.024": "Epidemiology Research (Life Sciences)",
  "ENS.07.025": "Microbiology/Bacteriology Research (Life Sciences)",
  "ENS.07.026": "Pathology Research (Life Sciences)",
  "ENS.07.027": "Pharmacokinetics/Drug Metabolism Research (Life Sciences)",
  "ENS.07.028": "Pharmacology/Pharmaceutics Research (Life Sciences)",
  "ENS.07.029": "Toxicology Research (Life Sciences)",
  "ENS.07.030": "Translational Medicine (Life Sciences)",
  "ENS.07.031": "Discovery Biology (Agriculture)",
  "ENS.07.032": "Discovery Chemistry (Agriculture & Life Sciences)",
  "ENS.07.033": "Lab Research Science (Agriculture)",
  "ENS.07.034": "Field Research Science (Agriculture)",
  "ENS.07.035": "Field Production Science: Agronomy (Agriculture)",
  "ENS.07.037": "Perfume/Flavor Research",
  "ENS.07.038": "Sensory Evaluation Research",
  "ENS.07.040": "Food Science",
  "ENS.07.043": "Molecular Biology (Life Sciences)",
  "ENS.07.044": "Pharmaceutical/Biological Process Development (Life Sciences)",
  "ENS.07.045": "Veterinarian (Life Sciences)",
  "ENS.07.046": "Veterinary Research (Animal Health)",
  "ENS.07.047": "Assay Development (Life Sciences)",
  "ENS.07.048": "Biologic Product Formulation (Life Sciences)",
  "ENS.07.049": "Biological Process: Fermentation/Cell Culture (Life Sciences)",
  "ENS.07.050": "Biological Process: Purification/Recovery (Life Sciences)",
  "ENS.07.051": "Imaging Biomarkers (Life Sciences)",
  "ENS.07.052": "Modeling and Simulation (PK/PD) (Life Sciences)",
  "ENS.07.053": "Microbiology: Alcoholic Beverages",
  "ENS.07.056": "Science R&D Analytics: Bioinformatics (Life Sciences)",
  "ENS.07.057": "Science R&D Analytics: Biostatisticians (Life Sciences)",
  "ENS.07.058": "Science R&D Analytics: Bioinformatics (Agriculture)",
  "ENS.07.060": "Computational Chemistry Drug Discovery (Life Sciences)",
  "ENS.07.079": "Environmental Science (Construction, Energy & Mining)",
  "ENS.07.099": "Geology",
  "ENS.07.100": "Hydrogeology",
  "ENS.07.101": "Exploration Geology (Oil & Gas, Mining)",
  "ENS.07.102": "Mine Site Geology (Mining)",
  "ENS.07.104": "Mineral Resource Compliance Geology (Mining)",
  "ENS.07.105": "Geophysics (Construction, Oil & Gas)",
  "ENS.07.106": "Exploration Geophysics (Oil & Gas, Mining)",
  "ENS.07.107": "Petrophysics (Oil & Gas)",
  "ENS.07.120": "Meteorology",
  "ENS.07.121": "Wind Resource Assessment (Utilities)",
  "ENS.08.000": "No Specialization",
  "ENS.09.000": "No Specialization",
  "ENS.10.000": "No Specialization",
  "ENS.10.001": "Project Engineering Technologist/Technician",
  "ENS.10.002": "Project Planning/Scheduling Technician",
  "ENS.10.003": "Power Systems Planning and Design Technologist/Technician (Utilities)",
  "ENS.10.004": "General Engineering Technologists & Technicians",
  "ENS.10.015": "Manufacturing Production Technician",
  "ENS.10.016": "Robotics Technician",
  "ENS.10.017": "Manufacturing Instrumentation/Calibration Technician",
  "ENS.10.018": "Chemical Process Technologist/Technician",
  "ENS.10.019": "Biochemical Manufacturing Technician (Life Sciences)",
  "ENS.10.020": "Field Production Engineering Technologist/Technician (Oil & Gas)",
  "ENS.10.021": "Well Asset Technologist/Technician (Oil & Gas)",
  "ENS.10.035": "Mechanical Equipment Technologist/Technician",
  "ENS.10.036": "Electronic Equipment Technician",
  "ENS.10.037": "Electro-Mechanical Technologist/Technician",
  "ENS.10.038": "Electrical Engineering Technologist/Technician",
  "ENS.10.039": "Electrical Instrumentation & Control Technologist/Technician",
  "ENS.10.040": "SCADA Technologist/Technician",
  "ENS.10.042": "Completions Technologist/Technician (Oil & Gas)",
  "ENS.10.043": "Gas Measurement Technologist/Technician (Oil & Gas)",
  "ENS.10.044": "Gas Operations Technologist/Technician (Oil & Gas)",
  "ENS.10.045": "Field Metering Technologist/Technician (Oil & Gas, Utilities & Power)",
  "ENS.10.048": "Power Systems Technologist/Technician (Utilities & Power)",
  "ENS.10.051": "Laser Technician",
  "ENS.10.052": "Optical Technician (High Tech)",
  "ENS.10.060": "Quality Technician",
  "ENS.10.061": "Quality Assurance Technologist/Technician",
  "ENS.10.062": "Pipeline Leak Detection Technologist/Technician (Oil & Gas)",
  "ENS.10.063": "Corrosion/Integrity Technologist/Technician (Oil & Gas)",
  "ENS.10.064": "Field Inspection Technician ( Energy & Mining)",
  "ENS.10.066":
    "Product Measurement/Quality Control Technologist/Technician (Oil & Gas/Oilfield Services)",
  "ENS.10.067": "Reliability/Failure Analysis Technician",
  "ENS.10.075": "Environmental Engineering Technician",
  "ENS.10.076": "Employee/Labor Health & Safety Technician",
  "ENS.10.085": "Field Service Technician",
  "ENS.10.087": "Field Service Technician - Oilfield Services ( Oil & Gas)",
  "ENS.10.088": "Field Technologist/Technician (Oil & Gas)",
  "ENS.10.090": "Technical Support Engineering Technician (High Tech)",
  "ENS.10.095": "Facilities Engineering Technologist/Technician",
  "ENS.10.096": "Plant/Facilities Infrastructure Technician",
  "ENS.10.097": "Compression & Controls Technologist/Technician",
  "ENS.10.098": "Plant Technologist/Technician",
  "ENS.10.099": "Pipeline/Piping Engineering Technologist/Technician (Oil & Gas)",
  "ENS.10.105": "Civil Engineering Technologist/Technician",
  "ENS.10.106": "Structural Engineering Technologist/Technician",
  "ENS.10.108": "Geological Technologist/Technician (Energy & Mining)",
  "ENS.10.109": "Geophysical Technologist/Technician (Oil & Gas)",
  "ENS.10.110": "Geotechnical Engineering Technologist/Technician (Oil & Gas, Mining)",
  "ENS.10.111": "Geomatics Technologist/Technician (Oil & Gas)",
  "ENS.10.125": "Network Field Installation & Integration Technologist (Telecommunications)",
  "ENS.10.134": "Telecommunications/Splicing Technologist/Technician (Telecommunications)",
  "ENS.10.145": "Drilling Engineering Technologist/Technician (Oil & Gas)",
  "ENS.10.146": "Reservoir/Exploitation Engineering Technologist/Technician (Oil & Gas)",
  "ENS.10.147": "Mine Technologist/Technician (Mining)",
  "ENS.11.001": "Head of Engineering Program Management (High Tech)",
  "FIN.01.001": "Head of Finance & Accounting (CFO)",
  "FIN.02.000": "No Specialization",
  "FIN.04.000": "No Specialization",
  "FIN.05.000": "No Specialization",
  "FIN.06.000": "No Specialization",
  "FIN.07.000": "No Specialization",
  "FIN.08.000": "No Specialization",
  "FIN.09.000": "No Specialization",
  "FIN.10.000": "No Specialization",
  "GMA.01.003": "Head of Organization (CEO)",
  "GMA.01.004": "Chief Operating Officer (COO)/Head of Operations",
  "GMA.01.005": "Head of Administration",
  "GMA.01.008": "Head of Commercial/Chief Commercial Officer (CCO)",
  "GMA.02.000": "No Specialization",
  "GMA.03.000": "No Specialization",
  "GMA.03.001": "Chief Risk Officer (CRO)",
  "HLT.03.000": "No Specialization",
  "HLT.04.011": "Nursing Management (RN) (Healthcare)",
  "HLT.04.012": "Registered Nurse (RN) (Healthcare)",
  "HLT.04.013": "Licensed Practical/Vocational Nurse (LPN/LVN) (Healthcare)",
  "HLT.04.014": "General Nursing Assistant/Aid (Healthcare)",
  "HLT.04.015": "Nurse Practitioner (Healthcare)",
  "HLT.04.025": "Occupational Health Nursing",
  "HLT.04.035": "Nurse Midwife (Healthcare)",
  "HLT.04.055": "Physician Assistant (Healthcare)",
  "HLT.05.000": "No Specialization",
  "HLT.05.001": "Head of Pharmacy (Healthcare)",
  "HLT.05.002": "Head of Pharmacy (Health Insurance)",
  "HLT.05.020": "Multi-Pharmacy Operations Management (Retail)",
  "HLT.05.021": "Pharmacy Management",
  "HLT.05.022": "Mail Order Pharmacy Center Management (Health Insurance)",
  "HLT.05.023": "Pharmacy Management: PBM/Managed Care (Health Insurance)",
  "HLT.05.024": "Pharmacy Formulary Management (Health Insurance)",
  "HLT.05.031": "Registered Staff Pharmacist",
  "HLT.05.032": "Registered Staff Pharmacist: Specialty",
  "HLT.05.033": "Registered Staff Pharmacist: Remote Pharmacy Services",
  "HLT.05.034": "Clinical Pharmacist (Healthcare & Health Insurance)",
  "HLT.05.035": "Infusion Pharmacist (Healthcare)",
  "HLT.05.036": "Nuclear Pharmacist (Healthcare)",
  "HLT.05.037": "Pharmacy Clinical Consultant",
  "HLT.05.045": "Pharmacy Intern",
  "HLT.05.046": "Pharmacy Resident (Healthcare)",
  "HLT.05.055": "Pharmacy Technician (Retail)",
  "HLT.05.056": "Pharmacy Technician (Healthcare & Life Sciences)",
  "HLT.05.057": "Pharmacy Technician (Health Insurance)",
  "HLT.05.058": "Pharmacy Technician: PBM/Managed Care",
  "HLT.05.059": "Pharmacy Technician: Specialty",
  "HLT.05.060": "Infusion/Intravenous Pharmacy Technician (Healthcare)",
  "HLT.07.000": "No Specialization",
  "HLT.12.000": "No Specialization",
  "HLT.12.001": "Beauty Salon Services",
  "HLT.12.011": "Child Care",
  "HLT.12.021": "Water Safety & Rescue",
  "HLT.12.030": "Gym/Fitness Center Management",
  "HLT.12.031": "Gym/Fitness Instruction",
  "HLT.12.041": "Massage/Spa Therapy",
  "HLT.12.051": "Spa Management",
  "HPY.02.000": "No Specialization",
  "HPY.03.000": "No Specialization",
  "HPY.04.000": "No Specialization",
  "HPY.04.001": "Executive Chef (Hospitality & Retail)",
  "HPY.04.002": "Executive Sous Chef (Hospitality & Retail)",
  "HPY.04.004": "Pastry Commis Chef (Hospitality & Retail)",
  "HPY.04.005": "Baker (Hospitality & Retail)",
  "HPY.04.006": "Cake Decoration (Hospitality & Retail)",
  "HPY.04.007": "Commis Chef/Line Cook",
  "HPY.04.008": "Prep Cook",
  "HPY.04.009": "Food Service Cook",
  "HPY.04.056": "Alcoholic Beverage Preparation & Service (Hospitality & Retail)",
  "HPY.04.057": "Wine Service (Sommelier) (Hospitality & Retail)",
  "HPY.04.058": "Coffee/Tea Preparation & Service (Barista) (Hospitality & Retail)",
  "HPY.05.000": "No Specialization",
  "HRM.01.001": "Head of Human Resources",
  "HRM.02.000": "No Specialization",
  "HRM.03.000": "No Specialization",
  "HRM.04.000": "No Specialization",
  "HRM.05.000": "No Specialization",
  "HRM.06.000": "No Specialization",
  "HRM.07.000": "No Specialization",
  "HRM.08.000": "No Specialization",
  "HRM.09.000": "No Specialization",
  "HRM.10.000": "No Specialization",
  "INS.02.000": "No Specialization",
  "INS.02.001": "Head of Underwriting (Insurance)",
  "INS.02.002": "Underwriting (Insurance)",
  "INS.02.004": "New Policy Administration (Insurance)",
  "INS.02.005": "Loss Control (Insurance)",
  "INS.02.006": "Rating (Insurance)",
  "INS.02.007": "Reinsurance (Insurance)",
  "INS.03.000": "No Specialization",
  "INS.03.001": "Head of Claims (Insurance)",
  "INS.05.000": "No Specialization",
  "INS.06.000": "No Specialization",
  "INS.07.000": "No Specialization",
  "ITC.01.001": "Head of Information Technology (CIO)",
  "ITC.01.002": "Head of Digital Technology",
  "ITC.01.004": "Chief Technology Officer",
  "ITC.02.000": "No Specialization",
  "ITC.02.001": "General Information Technology",
  "ITC.02.002": "IT Portfolio Management",
  "ITC.02.003": "Information Technology Outsourcing/Shared Services Management",
  "ITC.02.004": "IT Software Development & Operations (DevOps)",
  "ITC.03.001": "Enterprise Architecture",
  "ITC.03.002": "Enterprise Data Architecture",
  "ITC.03.003": "IT Infrastructure/Systems Architecture",
  "ITC.03.004": "Middleware Architecture",
  "ITC.03.005": "Cloud Computing Architecture",
  "ITC.03.006": "Cyber Security Architecture",
  "ITC.03.007": "Technology Research",
  "ITC.03.008": "IT Solution Architecture (High Tech)",
  "ITC.03.009": "Internet of Things (IoT) Platform Development",
  "ITC.04.000": "No Specialization",
  "ITC.04.001": "IT Systems Analysis",
  "ITC.04.002": "PC Systems Analysis",
  "ITC.04.003": "User Liaison Coordination",
  "ITC.04.004": "IT Telecommunications Network Analysis & Planning",
  "ITC.04.005": "Data & Voice Network Control Analysis",
  "ITC.04.006": "IT Business Systems Analysis",
  "ITC.04.007": "Enterprise Resource Planning (ERP) Business Analysis",
  "ITC.04.008": "Enterprise Resource Planning (ERP) Business Analysis: SAP",
  "ITC.04.009": "Enterprise Resource Planning (ERP) Business Analysis: Oracle-PeopleSoft",
  "ITC.04.010": "Social Networking & Collaboration Tools Analysis",
  "ITC.04.012": "Robotic Process Automation (RPA) Analysis",
  "ITC.05.000": "No Specialization",
  "ITC.05.001": "Enterprise Resource Planning (ERP) Configuration & Implementation",
  "ITC.05.002": "Enterprise Resource Planning (ERP) Configuration & Implementation: SAP",
  "ITC.05.003":
    "Enterprise Resource Planning (ERP) Configuration & Implementation: Oracle-PeopleSoft",
  "ITC.05.005": "Social Networking Tools Configuration & Programming",
  "ITC.05.006": "IT Systems Software Analysis & Programming",
  "ITC.05.007": "IT Systems Software Programming",
  "ITC.05.008": "Telecommunications Systems Software Programming",
  "ITC.05.009": "Robotic Process Automation (RPA) Configuration & Programming",
  "ITC.05.010": "Manufacturing Execution Systems (MES) Configuration & Implementation",
  "ITC.05.011": "Laboratory Automation & Process Technology",
  "ITC.06.001": "General IT Applications Development",
  "ITC.06.002": "General IT Mobile Applications Development",
  "ITC.06.003": "IT Software Manual Testing",
  "ITC.06.006": "Blockchain Development (Financial Services & High Tech)",
  "ITC.06.022": "General IT Systems Software Development",
  "ITC.06.023": "IT Software Development Test Engineering",
  "ITC.06.033": "Information Assurance Systems Development",
  "ITC.06.042": "E-Commerce Web Operations",
  "ITC.06.044": "Website Design & Development: Communications & Marketing",
  "ITC.06.045": "Website Development: E-Commerce",
  "ITC.06.046": "IT Technical Web Administration",
  "ITC.06.047": "Website Search Engine Optimization (SEO)",
  "ITC.06.048": "Internet Banking Web Operations (Financial Services)",
  "ITC.07.000": "No Specialization",
  "ITC.08.001": "General IT Infrastructure Systems Administration",
  "ITC.08.002": "UNIX Systems Administration",
  "ITC.08.003": "Office Technology Administration",
  "ITC.08.004": "Email Administration",
  "ITC.08.005": "Groupware Administration",
  "ITC.08.006": "IT Capacity Planning",
  "ITC.08.007": "IT System Release Administration",
  "ITC.08.009": "Head of Computer Operations & Data Processing (Retail)",
  "ITC.08.010": "Point of Sale Systems Administration & Data Processing (Retail)",
  "ITC.08.011": "IT Systems Incident Management",
  "ITC.08.012": "SharePoint Administration",
  "ITC.08.013": "IT Configuration Management",
  "ITC.08.014": "Machine Room Monitoring",
  "ITC.08.015": "Mobile Infrastructure Administration",
  "ITC.08.031": "IT Data/Voice Network Administration",
  "ITC.08.032": "IT Server Administration",
  "ITC.08.033": "IT Storage Administration",
  "ITC.08.054": "IT Data Center Facility Operations",
  "ITC.08.074": "IT Database Administration",
  "ITC.08.075": "Database Administration: Oracle",
  "ITC.08.076": "Database Dictionary Administration",
  "ITC.08.077": "Database Administration: SQL Server",
  "ITC.08.078": "Clinical Trial Database Development/Administration (Life Sciences)",
  "ITC.09.000": "No Specialization",
  "ITC.10.000": "No Specialization",
  "ITC.11.000": "No Specialization",
  "ITC.12.000": "No Specialization",
  "ITC.13.001": "Software Architecture Engineering (Automotive, High Tech)",
  "ITC.13.002": "Software Architecture Engineering: Mobile Applications (High Tech)",
  "ITC.13.004": "Application Architecture Engineering (High Tech)",
  "ITC.13.015": "Software Development Engineering (High Tech)",
  "ITC.13.016": "Software Development Engineering: R&D (High Tech)",
  "ITC.13.017": "Software Development Engineering: End User Applications (High Tech)",
  "ITC.13.018": "Web Applications Development Engineering (High Tech)",
  "ITC.13.019": "Web Applications Design & Development Engineering (High Tech)",
  "ITC.13.020": "Client-End Software Development Engineering (High Tech)",
  "ITC.13.021": "Back-End Server Application Development Engineering (High Tech)",
  "ITC.13.024": "Algorithm Development Engineering (High Tech)",
  "ITC.13.026": "Virtual Reality Applications Development Engineering (Media & High Tech)",
  "ITC.13.028": "Application Security (High Tech)",
  "ITC.13.049": "Systems Software Engineering (High Tech)",
  "ITC.13.050": "Platform Development Engineering (High Tech)",
  "ITC.13.051": "Firmware Engineering (High Tech)",
  "ITC.13.105": "Cloud Software-As-A-Service (SAAS) (High Tech)",
  "ITC.13.106": "Cloud Platform-As-A-Service (PAAS) (High Tech)",
  "ITC.13.107": "Cloud Infrastructure-As-A-Service (IAAS) (High Tech)",
  "ITC.13.117": "Integrated Solutions (Hardware & Software) Engineering (High Tech)",
  "ITC.15.000": "No Specialization",
  "LCA.01.001": "Head of Corporate Compliance & Legal",
  "LCA.01.002": "Head of Corporate Compliance (Including Regulatory Affairs)",
  "LCA.02.000": "No Specialization",
  "LCA.03.000": "No Specialization",
  "LCA.03.001": "Head of Legal",
  "LCA.03.011": "Legal Counsel: General Business",
  "LCA.03.012": "Legal Counsel: Patent/Intellectual Property",
  "LCA.03.013": "Legal Counsel: Litigation",
  "LCA.03.014": "Legal Counsel: Regulatory",
  "LCA.03.015": "Legal Counsel: Commercial/Corporate",
  "LCA.03.037": "Legal Research/Paralegal",
  "LCA.03.039": "Legal/Regulatory Records Management",
  "LCA.03.040": "General Legal Contract Management",
  "LCA.03.041": "Land Contracts & Negotiations",
  "LCA.03.042": "Land Contracts Analysis",
  "LCA.03.050": "Patent Preparation & Prosecution",
  "LCA.03.051": "Patent/Intellectual Property Search (Professional Services)",
  "LCA.03.086": "Service Provider Contracts Management (Life Sciences)",
  "LCA.04.000": "No Specialization",
  "LCA.04.048": "Medical Affairs - Non M.D. (Life Sciences)",
  "LCA.05.000": "No Specialization",
  "LCA.06.000": "No Specialization",
  "LCA.07.000": "No Specialization",
  "LCA.09.000": "No Specialization",
  "PPM.01.000": "No Specialization",
  "PPM.02.000": "No Specialization",
  "PPM.02.001": "Technical Program Management Office (PMO)",
  "PPM.02.002": "Technical Project Management",
  "PPM.02.022": "Research & Development Portfolio Management",
  "PPM.02.023": "Clinical Research Project Management (Life Sciences)",
  "PPM.02.043": "Scrum Product Ownership",
  "PPM.02.044": "Scrum Master",
  "PPM.02.045": "Technical Project Management: e-Commerce",
  "PPM.02.046": "Technical Project Management: Web Development",
  "PPM.02.068": "IT/Business Process Delivery Management",
  "PPM.02.073": "Client Benefit Plan Project Management (Health Insurance)",
  "PPM.02.074": "Client Benefit Plan Project Management: Implementation (Health Insurance)",
  "PPM.02.092": "Asset Project/Program Management (Renewables)",
  "PPM.02.093": "Wind Turbine Testing Project Management (Renewables)",
  "PPM.03.000": "No Specialization",
  "PSK.01.000": "No Specialization",
  "PSK.01.001": "Head of Manufacturing & Engineering",
  "PSK.01.002": "Head of Manufacturing",
  "PSK.02.000": "No Specialization",
  "PSK.02.002": "Manufacturing Production Workers",
  "PSK.02.003": "Production Shift/Group Leader",
  "PSK.02.005": "Production Tools Handling",
  "PSK.02.010": "Chemical Plant Outside Operator",
  "PSK.02.011": "Chemical Plant Control Room Operator",
  "PSK.02.016": "Wafer Fab Operations (High Tech)",
  "PSK.02.022": "Manufacturing Assembly",
  "PSK.02.023": "Manufacturing Packaging",
  "PSK.02.024": "Manufacturing Sewing Machine",
  "PSK.02.025": "Electrical Installation Assembly",
  "PSK.02.026": "Precision Electromechanical Assembly",
  "PSK.02.027": "Aircraft Structural Assembly (High Tech)",
  "PSK.02.044": "Manufacturing Chemical Process Operations",
  "PSK.02.045": "Manufacturing Pharmaceutical Process Operations (Life Sciences)",
  "PSK.02.046": "Composite/Metal Bonding",
  "PSK.02.065": "Manufacturing Production Painting",
  "PSK.03.000": "No Specialization",
  "PSK.04.000": "No Specialization",
  "PSK.04.002": "Manufacturing Machine Operations",
  "PSK.04.003": "Tool & Die Making Operations",
  "PSK.04.004": "Mold Making Operations",
  "PSK.04.005": "Metal Part Machining Operations",
  "PSK.04.006": "Metalworking Operations",
  "PSK.04.007": "Plastic Injection Molding Operations",
  "PSK.04.009": "Computer Numeric Control (CNC) Operations",
  "PSK.04.010": "Coordinate Measuring Machine (CMM) Programming",
  "PSK.04.011": "Coordinate Measuring Machine (CMM) Operations",
  "PSK.04.012": "Aircraft Sheet Metal Technician (High Tech)",
  "PSK.05.000": "No Specialization",
  "PSK.05.001": "General Repair & Maintenance Trades Management",
  "PSK.05.002": "Repair & Maintenance Carpentry",
  "PSK.05.003": "Repair & Maintenance Plumbing",
  "PSK.05.004": "Repair & Maintenance Electrical",
  "PSK.05.005": "Repair & Maintenance Welding",
  "PSK.05.006": "Repair & Maintenance Painting",
  "PSK.05.007": "Repair Center Technician",
  "PSK.05.008": "Repair & Maintenance Electrical & Instrumentation",
  "PSK.05.009": "Insulation Services",
  "PSK.05.010": "Gas Appliances/Equipment Repair",
  "PSK.05.011": "Locksmithing",
  "PSK.05.012": "Repair & Maintenance Electronic Locking Equipment",
  "PSK.05.013": "Repair & Maintenance Masonry",
  "PSK.05.026": "Manufacturing Repair & Maintenance Management",
  "PSK.05.046": "Mechanic: HVAC",
  "PSK.05.047": "Mechanic: Industrial Machinery",
  "PSK.05.048": "Mechanic: Refrigeration",
  "PSK.05.049": "Mechanic: Ammonia Refrigeration",
  "PSK.05.050": "Mechanic: Forklift",
  "PSK.05.051": "Boiler Operator",
  "PSK.05.067": "Mechanic: Tractor/Trailer",
  "PSK.05.068": "Mechanic: Light Vehicle",
  "PSK.05.069": "Hazardous Material Transportation Cleaning",
  "PSK.05.070": "Truck Maintenance",
  "PSK.05.089": "Auto Mechanic/Technician (Auto Dealers & Manufacturers)",
  "PSK.05.092": "Auto Body Repair (Auto Dealers)",
  "PSK.05.093": "Auto Body Painting (Auto Dealers)",
  "PSK.05.094": "Automotive Service Technical Training (Auto Dealers)",
  "PSK.05.111": "Steamfitter (Oil & Gas, Mining)",
  "PSK.05.117": "Gas Meter/Pipes Installation, Maintenance & Repair (Utilities)",
  "PSK.05.122": "Marine Engine Room Crew",
  "PSK.05.135": "Aircraft Mechanic",
  "PSK.05.136": "Aircraft Base Maintenance Management (Air Transportation)",
  "PSK.05.137": "Aircraft Line Maintenance Management (Air Transportation)",
  "PSK.05.138": "Aircraft Maintenance Control (Air Transportation)",
  "PSK.05.139": "Aircraft Vendor Maintenance Management",
  "PSK.05.140": "Avionics/Electrical Technician",
  "PSK.05.141": "Flight Simulation Maintenance",
  "PSK.05.142": "Survival Equipment Technician (High Tech)",
  "PSK.06.000": "No Specialization",
  "PSK.06.001": "Heavy Equipment Operators",
  "PSK.06.002": "Mobile/Hydraulic Crane Operator",
  "PSK.06.003": "Crane Operator",
  "PSK.06.004": "Shovel/Excavator Operator",
  "PSK.06.005": "Ancillary Equipment Operator",
  "PSK.06.006": "Dozer Operator",
  "PSK.06.007": "Grader Operator",
  "PSK.06.008": "Haul Truck Operator",
  "PSK.06.009": "Loader Operator",
  "PSK.06.012": "Underground Haulage Operator (Mining)",
  "PSK.06.014": "Surface Operator (Mining)",
  "PSK.06.015": "Underground Hoist Operator (Mining)",
  "PSK.06.025": "Light Equipment Operations",
  "PSK.06.040": "Heavy Equipment Mechanic",
  "PSK.06.041": "Heavy Equipment Mechanic: Tireperson",
  "PSK.08.000": "No Specialization",
  "QLT.01.001": "Head of Quality",
  "QLT.02.000": "No Specialization",
  "QLT.03.000": "No Specialization",
  "QLT.03.001": "Manufacturing Quality Assurance",
  "QLT.03.002": "Manufacturing Quality Control",
  "QLT.03.003": "Manufacturing Quality Improvement",
  "QLT.03.004": "Manufacturing Process Definition & Improvement",
  "QLT.03.005": "Good Manufacturing Practices (GMP)",
  "QLT.03.006": "Manufacturing Quality: Validation",
  "QLT.03.007": "Manufacturing Quality: Validation Support",
  "QLT.03.008": "Good Clinical Practices (GCP) (Life Sciences)",
  "QLT.03.009": "Tool & Gauge Inspection",
  "QLT.03.028": "Product Quality Assurance/Control",
  "QLT.03.029": "Product Quality Assurance",
  "QLT.03.030": "Product Quality Control/Inspection",
  "QLT.03.032": "Product Integrity: Color",
  "QLT.03.033": "Product Integrity: Wet Processing",
  "QLT.03.034": "Product Integrity: Fitting & Pattern",
  "QLT.03.036": "Product Integrity: Pattern",
  "QLT.03.038": "Marine Surveying",
  "QLT.03.039": "Product Complaint Management",
  "QLT.03.040": "Product Serialization & Security",
  "QLT.03.041": "Product Sterilization/Sanitation",
  "QLT.03.042": "Non-Destructive Test (NDT) Technician",
  "QLT.03.043": "Flight Operations Analysis (High Tech)",
  "QLT.03.044": "Aircraft Final Assembly Inspection (High Tech)",
  "QLT.03.045": "Aircraft Maintenance Quality Assurance (Air Transportation)",
  "QLT.03.046": "Aircraft Maintenance Quality (Air Transportation)",
  "QLT.03.047": "Stability Assessment Analysis (Life Sciences)",
  "QLT.03.048": "Deviation Management (Life Sciences)",
  "QLT.03.050": "Aircraft Reliability Analysis",
  "QLT.03.051": "Flight Safety & Inspection",
  "QLT.04.000": "No Specialization",
  "QLT.05.000": "No Specialization",
  "REA.01.000": "No Specialization",
  "REA.02.000": "No Specialization",
  "REA.03.000": "No Specialization",
  "REA.04.000": "No Specialization",
  "REA.05.000": "No Specialization",
  "RET.01.000": "No Specialization",
  "RET.01.001": "Head of Retail",
  "RET.02.000": "No Specialization",
  "RET.02.002": "Merchandise Receiving (Retail)",
  "RET.02.003": "Merchandise Receiving: Supermarket Direct Store Delivery (DSD) (Retail)",
  "RET.02.004": "Customer Check-out Support: Courtesy Clerk/Bagger (Retail)",
  "RET.02.005": "Photo Lab Operations (Retail)",
  "RET.02.006": "Butchering/Meat Cutting (Retail)",
  "RET.02.007": "Service Station Attendant (Retail)",
  "RET.02.026": "Merchandise Stocking (Retail)",
  "RET.02.027": "Supermarket Department Stocking (Retail)",
  "RET.02.047": "Field Operations (Non-Sales) (Retail)",
  "RET.05.000": "No Specialization",
  "RET.06.000": "No Specialization",
  "RET.06.003": "Merchandise Planning & Allocation (Retail)",
  "SCN.01.001": "Head of Supply Chain",
  "SCN.02.000": "No Specialization",
  "SCN.03.001": "Procurement",
  "SCN.03.002": "Procurement Business Partners",
  "SCN.03.003": "Strategic Sourcing",
  "SCN.03.005": "Supplier Relationship Management",
  "SCN.03.006": "Procurement Contract & Bid Administration",
  "SCN.03.007": "IT Procurement",
  "SCN.03.008": "IT Asset Administration",
  "SCN.03.009": "Procurement Vendor Management",
  "SCN.03.010": "Buyer (Retail)",
  "SCN.03.013": "Responsible/Sustainable Sourcing",
  "SCN.03.014": "Gas Procurement (Utilities & Power)",
  "SCN.03.015": "Procurement Analysis",
  "SCN.03.016": "Pharmacy Purchasing (Healthcare & Retail)",
  "SCN.03.017": "Materials Sourcing",
  "SCN.03.018": "Merchandise Sourcing & External Production",
  "SCN.03.019": "Procurement/Sourcing Systems",
  "SCN.03.020": "Subcontract Administration",
  "SCN.03.021": "Vendor Warranty Administration",
  "SCN.03.022": "Intellectual Property (IP) Procurement",
  "SCN.03.023": "Purchasing Price Analysis",
  "SCN.03.025": "Head of Offshore Production & Import Coordination",
  "SCN.03.026": "Supplier Diversity",
  "SCN.03.029": "Materials Planning & Control",
  "SCN.03.030": "Materials Procurement & Inventory Management",
  "SCN.03.031": "Materials Forecasting",
  "SCN.03.035": "Material Requirements Planning",
  "SCN.03.036": "Air Fuel Procurement (Air Transportation)",
  "SCN.03.054": "Manufacturing Finished Goods Demand Analysis & Planning",
  "SCN.03.055": "Manufacturing Finished Goods Inventory Planning & Control",
  "SCN.04.000": "No Specialization",
  "SCN.04.001": "General Logistics Operations",
  "SCN.04.002": "Logistics Planning & Optimization",
  "SCN.04.003": "Supplier Managed Inventory",
  "SCN.04.007": "Logistics Documentation",
  "SCN.04.008": "Spares/Parts Provisioning",
  "SCN.05.001": "Warehouse Management",
  "SCN.05.002": "Distribution Center & Warehouse Management",
  "SCN.05.003": "Distribution Center Management",
  "SCN.05.004": "Inbound Operations Management",
  "SCN.05.005": "Outbound Operations Management",
  "SCN.05.007": "E-Commerce Fulfillment Center Management (Retail & Logistics)",
  "SCN.05.026": "Warehouse/Distribution Center Design & Optimization",
  "SCN.05.027": "General Warehouse Operations",
  "SCN.05.028": "Distribution Operations Analysis",
  "SCN.05.029": "Warehouse Shipping & Receiving",
  "SCN.05.030": "Materials Handling",
  "SCN.05.031": "Warehouse/Distribution Center Order Support",
  "SCN.05.032": "Order Filling: Picking & Packing",
  "SCN.05.033": "Forklift Operations",
  "SCN.05.034": "Yard Truck Switching/Spotting",
  "SCN.05.035": "Returns Processing",
  "SCN.05.037": "Airlines Stores Management (Air Transportation)",
  "SCN.05.040": "Head of Distribution",
  "SCN.05.041": "Head of Distribution Strategy",
  "SCN.05.042": "Distribution Operations Systems Analysis",
  "SCN.05.050": "Head of Order Fulfillment",
  "SCN.05.069": "Product Terminal/Distribution Operations (Oil & Gas)",
  "SCN.05.070": "Product Terminal/Distribution Operations Management (Oil & Gas)",
  "SCN.05.072": "Gas Transportation Control (Oil & Gas)",
  "SCN.06.000": "No Specialization",
  "SMP.01.001": "Head of Sales & Marketing",
  "SMP.01.002": "Head of Sales",
  "SMP.01.003": "Head of Marketing",
  "SMP.02.000": "No Specialization",
  "SMP.02.021": "Business Development Strategy & Planning",
  "SMP.03.000": "No Specialization",
  "SMP.04.000": "No Specialization",
  "SMP.04.119": "Medical Writing (Life Sciences)",
  "SMP.04.120": "Medical Science Liaison - Non M.D. (Life Sciences)",
  "SMP.05.000": "No Specialization",
  "SMP.06.000": "No Specialization",
  "SMP.07.000": "No Specialization",
  "SMP.08.000": "No Specialization",
  "SMP.09.000": "No Specialization",
  "SMP.09.001": "Account Management/Key Accounts",
  "SMP.10.000": "No Specialization",
  "SMP.11.000": "No Specialization",
  "SMP.12.000": "No Specialization",
  "TNS.02.000": "No Specialization",
  "TNS.03.000": "No Specialization",
  "TNS.03.004": "Transit Driver/Operator",
  "TNS.03.005": "Road Delivery Dispatching",
  "TNS.03.026": "Messenger/Courier",
  "TNS.03.035": "Employee Chauffeur",
  "TNS.03.036": "Light Truck Delivery Drivers",
  "TNS.03.037": "Heavy Truck Delivery Drivers",
  "TNS.03.038": "Specialized Freight Truck Drivers",
  "TNS.03.041": "Vehicle Delivery Driver",
  "TNS.03.047": "Food Delivery Driver (Hospitality & Retail)",
  "TNS.05.012": "Aviation & Flight Operations Management",
  "TNS.05.020": "Air Charter Operations (Air Transportation)",
  "TNS.05.028": "System Operations Control (Air Transportation)",
  "TNS.05.029": "Flight Scheduling/Planning (Air Transportation)",
  "TNS.05.030": "Flight Dispatch (Air Transportation)",
  "TNS.05.031": "Aircraft Routing (Air Transportation)",
  "TNS.05.035": "Aircraft Records (Air Transportation)",
  "TNS.05.036": "Aircraft Overhaul Planning/Scheduling (Air Transportation)",
  "TNS.05.041": "Crew Planning (Air Transportation)",
  "TNS.05.042": "Crew Scheduling/Tracking (Air Transportation)",
  "TNS.05.045": "Aircraft Pilot",
  "TNS.05.046": "Aircraft Test Pilot (High Tech)",
  "TNS.05.048": "Aircraft Flight Attendants",
  "TNS.05.050": "In-flight Administration (Air Transportation)",
  "TNS.05.056": "Cargo Programs (Air Transportation)",
  "TNS.05.057": "Cargo Claims Management (Air Transportation)",
  "TNS.05.058": "Central Baggage Service (Air Transportation)",
  "TNS.05.070": "Unmanned Aerial Vehicle Pilot",
  "TNS.05.071": "Unmanned Aerial Vehicle Operator",
  "TNS.05.077": "Airport Station Management (Air Transportation)",
  "TNS.05.079": "Irregular Flight Operations Coordination (Air Transportation)",
  "TNS.05.080": "Tower/Traffic Control (Air Transportation)",
  "TNS.05.081": "Ramp/Sort Handling (Air Transportation)",
  "TNS.05.101": "Pilot Qualification Training (Air Transportation)",
  "TNS.05.102": "Pilot Ground School Training (Air Transportation)",
  "TNS.05.103": "Flight Simulation Training",
  "TNS.05.104": "In-flight Training (Air Transportation)",
  "TNS.05.105": "Crew Training Records (Air Transportation)",
  "TNS.05.106": "Aircraft Maintenance Training",
  "TNS.05.107": "Aircraft Maintenance Training Records (Air Transportation)",
  "TRD.01.000": "No Specialization",
  "TRD.03.000": "No Specialization",
  "TRD.04.000": "No Specialization",
};

export const getSpecializationLabel = (
  family: string,
  sub_family: string,
  specialization: string,
) =>
  // @ts-expect-error TS7053
  jobCodeToSpecializationTitleMap[`${family}.${sub_family}.${specialization}`] ??
  `${specialization === "000" ? "All Specializations" : specialization}`;

// Map for Mercer/Comptryx option labels used in filters
export const mercerOptionLabelMap: Record<string, string> = {
  "Less than 100 in whole numbers": "<100",
  "100 to less than 250 in whole numbers": "100 to 249",
  "250 to less than 500 in whole numbers": "250 to 499",
  "500 to less than 1000 in whole numbers": "500 to 999",
  "1000 to less than 2500 in whole numbers": "1000 to 2499",
  "2500 or more in whole numbers": "2500+",
  "Less than 100 US Dollar in millions": "<$100M",
  "100 to less than 200 US Dollar in millions": "$100M to $199M",
  "200 to less than 400 US Dollar in millions": "$200M to $399M",
  "400 to less than 700 US Dollar in millions": "$400M to $699M",
  "700 to less than 1000 US Dollar in millions": "$700M to $999M",
  "1000 to less than 2000 US Dollar in millions": "$1B to $1.99B",
  "2000 or more US Dollar in millions": "$2B+",
  1: "Tier 1",
  2: "Tier 2",
  3: "Tier 3",
  4: "Tier 4",
};
